import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const typeFromRegister = api((registerId, type) =>
    !type
        ? null
        : query(
              gql`
                  query GetTypeFromRegister($registerId: String!, $type: String!) {
                      typeFromRegister(registerId: $registerId, type: $type) {
                          name
                          type
                          originalType
                          doNotMap
                          reviewedTypeName
                          reviewedParent
                          reviewStatus
                          schedule_id
                          mappingOrigin
                          schedule_ids_manual
                          keywords
                          count
                          questions
                          feedbackAttemptId
                          schedules {
                              chosen
                              schedule_id
                              relevance
                              previously_mapped
                          }
                      }
                  }
              `,
              { registerId, type },
              { returns: "typeFromRegister" }
          )
)
